import { Link } from "react-router-dom";
import { basics } from "../../../basics";
import { useDispatch, useSelector } from "react-redux";
import { cartActions } from "../../../store/cart-slice";
import { fetchCartData, sendCartData } from "../../../store/cart-actions";
import { useEffect, useState } from "react";

const PurchaseInvoicePrices = () => {
  //   const dispatch = useDispatch();
  // const getLocalCheck = useCartItemsAreEqual();
  //   const cartItems = useSelector((state: any) => state.cart.items.items);
  const totalPrice = useSelector((state: any) => state.cart.totalPrice);
  const totalDiscountedPrice = useSelector(
    (state: any) => state.cart.totalDiscountedPrice
  );

  //  console.log('totalPrice,totalDiscountedPrice',totalPrice,totalDiscountedPrice);
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  // const deliveryAmount = useSelector(
  //   (state: any) => state.cart.items.deliveryAmount
  // );
  const deliveryAmount = useSelector(
    (state: any) => state.shopInfo.shopInfoData.deliveryAmount
  );
  const deliveryAmountDiscountedFrom = useSelector(
    (state: any) => state.shopInfo.shopInfoData.deliveryAmountDiscountedFrom
  );
  useEffect(() => {
    if (deliveryAmountDiscountedFrom > totalPrice) {
      setDeliveryPrice(deliveryAmount);
    } else {
      setDeliveryPrice(0);
    }
  }, [deliveryAmount, deliveryAmountDiscountedFrom, totalPrice]);
  //   const AllProductsQuantity = useSelector(
  //     (state: any) => state.cart.totalQuantity
  //   );
  //   const cart = useSelector((state: any) => state.cart);
  //   const Token = useSelector((state: any) => state.auth.token);
  //   const checkCartHandler = () => {
  //     dispatch(cartActions.toggleChanges());
  //     dispatch(fetchCartData(Token));
  //     dispatch(sendCartData(cart, Token));
  //     //console.log("checkCartHandler");
  //   };

  const finalPrice =
    (totalPrice === totalDiscountedPrice ? totalPrice : totalDiscountedPrice) +
    deliveryPrice;

  return (
    <div className="space-y-2.5 text-sm">
      {totalPrice === totalDiscountedPrice ? (
        <div className="flex items-center justify-between">
          <p className="text-gray-500">{basics.totalCost}</p>
          <p className="font-bold text-gray-900">{`${totalPrice.toLocaleString()} ${basics.priceName}`}</p>
        </div>
      ) : (
        <div className="flex items-center justify-between rounded-lg bg-rose-50 px-2.5 py-2 text-rose-900">
          <p className="font-bold">{basics.totalCostWithDiscount}</p>
          <div className="flex flex-col items-end">
            <p className="text-xs text-gray-400 line-through">{`${totalPrice.toLocaleString()} ${basics.priceName}`}</p>
            <p className="font-bold">{`${totalDiscountedPrice.toLocaleString()} ${basics.priceName}`}</p>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between">
        <p className="text-gray-500">{basics.shippingPrice}</p>
        {deliveryPrice !== 0 ? (
          <p className="font-bold text-gray-900">{`${deliveryPrice.toLocaleString()} ${basics.priceName}`}</p>
        ) : (
          <p className="rounded bg-orange-50 px-2 py-0.5 text-xs font-bold text-orange-600">
            {basics.freeShippingPrice}
          </p>
        )}
      </div>

      <div className="my-1 border-t border-dashed border-slate-200" />

      <div className="flex items-center justify-between">
        <p className="font-extrabold text-gray-900">{basics.totalPrice}</p>
        <p className="text-lg font-extrabold text-rose-700">{`${finalPrice.toLocaleString()} ${basics.priceName}`}</p>
      </div>
    </div>
  );
};

export default PurchaseInvoicePrices;
